import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { loadBetaHomeModel } from 'tio-employee/utils/beta/load-home-model';
import type { BetaHomeRouteModel } from 'tio-employee/utils/beta/load-home-model';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export interface HomeTwentyTwentySixModel {
  beta: BetaHomeRouteModel;
}

/**
 * Brand Updates 2026 home — the full-page treatment.
 *
 * Same page and same data as the beta branch of `/dashboard`; the difference is
 * the chrome. `/dashboard` renders the main column inside the current app
 * shell, this route renders the 2026 sidebar and page frame around it, which
 * `BETA_HOME_GAPS.md` lists as out of scope for that change.
 */
export default class AuthenticatedReimaginedHome2026Route extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model(): Promise<HomeTwentyTwentySixModel> {
    return { beta: await loadBetaHomeModel(this.reimaginedData) };
  }
}
